import React from "react";
import { IoMdClose } from "react-icons/io";
import { LuLogOut } from "react-icons/lu";

export default function GroupDetailsDialog({ data, onClose, handleLeftGroup,CURRENT_USER_ID }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-xl w-96">
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-xl font-medium">Group Details</h2>
          <IoMdClose className="h-7 w-7 cursor-pointer" onClick={onClose} />
        </div>
        <div className="flex justify-center">
          <div
            style={
              data?.groupProfileImage
                ? {
                    backgroundImage: `url(${data?.groupProfileImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }
                : {
                    backgroundColor: "#2bace2",
                    color: "white",
                  }
            }
            className="h-20 w-20 flex text-xl font-semibold  justify-center items-center rounded-full"
          >
            {!data?.groupProfileImage &&
              data?.groupName &&
              data?.groupName?.charAt(0)?.toUpperCase()}
          </div>
        </div>
        <div className="text-center py-3 font-semibold">{data?.groupName}</div>
        {/* User List Container - max-h keeps the modal from growing too big */}
        <div className="space-y-3 max-h-64 overflow-y-auto thin-scrollbar mb-6 pr-2">
          {Object.entries(data?.usersInfo).map(([key, value]) => (
            <div
              key={value?.sId}
              className="flex items-center justify-between p-2 hover:bg-gray-50 rounded-md transition-colors"
            >
              <div className="flex items-center gap-3">
                {value?.profileImageUrl ? (
                  <img
                    src={value?.profileImageUrl}
                    alt={value.name}
                    className="w-10 h-10 rounded-full object-cover border border-gray-200"
                  />
                ) : (
                  <div className="w-10 h-10 rounded-full text-white font-semibold bg-highlight flex justify-center items-center">
                    {value?.name && value?.name?.charAt(0)?.toUpperCase()}
                  </div>
                )}
                <span className="text-sm font-medium text-gray-700">
                  {value?.name}

                  <br />
                  <p className="text-xs text-gray-400"> {value?.email}</p>
                </span>
                {value?.id == data?.groupCreaterId && (
                  <div className="text-xs bg-highlight px-2 py-1 text-white rounded-full">
                    {" "}
                    Admin
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        {CURRENT_USER_ID != data?.groupCreaterId && (
          <div
            onClick={handleLeftGroup}
            className="text-red-500 cursor-pointer text-sm font-semibold flex items-center justify-center"
          >
            <LuLogOut />
            &nbsp; Exit Group
          </div>
        )}
      </div>
    </div>
  );
}
